import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../providers/rest.service';
import { ToastrService } from 'ngx-toastr';
import { Cari } from '../model/cari';
import { Master } from '../model/master';
import Swal from 'ngx-angular8-sweetalert2';

@Component({
  selector: 'app-cari-ekle-duzenle',
  templateUrl: './cari-ekle-duzenle.component.html',
  styleUrls: ['./cari-ekle-duzenle.component.css'],
})
export class CariEkleDuzenleComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  id: string = null;
  cari: Cari = null;
  sehirler: Master[] = null;
  currentAction: string;
  ACTION_YETKILI = 'yetkili';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private restService: RestService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        this.id = params.id;
        this.currentAction = params.action;

        if (this.id !== '0') {
          this.getCari();
        } else {
          this.cari = new Cari();
          this.cari.cariKodu = '';
          this.cari.firmaUnvani = '';
          this.cari.yetkiliKisi = '';
          this.cari.mailAdresi = '';
          this.cari.cCMailAdresler = '';
          this.cari.firmaAdresi = '';
          this.cari.sehirId = null;
          this.cari.ilce = '';
          this.cari.telefon = '';
          this.cari.cepTelefon = '';
          this.cari.faks = '';
          this.cari.vergiDairesi = '';
          this.cari.vergiNo = '';
          this.cari.tcNo = '';
          this.cari.ibanNo = '';
          this.cari.isFaturaKesilsin = false;
        }
        this.getSehirler();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getCari() {
    this.restService.cariDetay(this.id).subscribe((res) => {
      if (res) {
        this.cari = res;
      }
    });
  }

  save() {
    //UI validator
    if (!this.suitableCari()) return;

    // BackEnd validator
    const tcVergi = this.cari.tcNo ? this.cari.tcNo : this.cari.vergiNo;
    const which = this.cari.tcNo ? 0 : 1;

    this.restService.cariBul(tcVergi, which).subscribe((res) => {
      if (res !== 0 && this.id === '0') {
        // existing Cari
        Swal.fire(
          'Oops...',
          'Bu TC No veya Vergi No ile Cari kaydı bulunmaktadır.!',
          'error'
        );
      } else {
        const subscription = (res) => {
          this.toastrService.show('Kaydedildi', 'Başarılı');
          this.router.navigate(['cariler']);
        };
        if (this.id === '0') {
          this.restService.cariEkle(this.cari).subscribe(subscription);
        } else {
          this.restService.cariDuzenle(this.cari).subscribe((res) => {
            if (res) {
              this.restService.netsisCariKaydet(res).subscribe((res2) => {
                this.toastrService.success('Kayıt Başarılı!');
              });
            }
          });
        }
      }
    });
  }

  getSehirler() {
    this.restService.getMasterTypes([Master.Sehir]).subscribe((res) => {
      this.sehirler = res?.Sehir.map((x) => new Master(x));
    });
  }

  suitableCari() {
    //empty control
    if (!this.cari.mailAdresi) {
      Swal.fire('Oops...', 'E-posta adresi boş olamaz!', 'error');
      return false;
    }
    if (!this.cari.firmaAdresi) {
      Swal.fire('Oops...', 'Firma adresi boş olamaz!', 'error');
      return false;
    }

    if (!this.cari.ibanNo) {
      Swal.fire('Oops...', 'IBAN boş olamaz!', 'error');
      return false;
    }

    if (!this.cari.firmaUnvani) {
      Swal.fire('Oops...', 'Firma ünvanı boş olamaz!', 'error');
      return false;
    }
    if (!this.cari.vergiDairesi) {
      Swal.fire('Oops...', 'Vergi Dairesi boş olamaz!', 'error');
      return false;
    }
    //************ */

    //mail regex
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.cari.mailAdresi)
    ) {
      Swal.fire('Oops...', 'Lütfen uygun bir e-posta adresi giriniz.', 'error');
      return false;
    }

    //tcNo and vergiNo and vergiDairesi combine
    if (
      (this.cari.vergiNo && this.cari.tcNo) ||
      (!this.cari.vergiNo && !this.cari.tcNo)
    ) {
      Swal.fire(
        'Oops...',
        'Yalnızca TC veya Vergi No Giriniz. İkiside dolu veya boş olamaz.!',
        'error'
      );
      return false;
    }

    if (
      this.cari.vergiNo &&
      !this.cari.tcNo &&
      this.cari.vergiNo.length !== 10
    ) {
      Swal.fire('Oops...', 'Vergi No 10 haneli olmalıdır.', 'error');
      return false;
    }

    if (this.cari.tcNo && !this.cari.vergiNo && this.cari.tcNo.length !== 11) {
      Swal.fire('Oops...', 'TC No 11 haneli olmalıdır.', 'error');
      return false;
    }

    if (this.cari.tcNo && !this.tcValidator(this.cari.tcNo)) {
      Swal.fire('Oops...', 'Lütfen geçerli bir TC No giriniz.', 'error');
      return false;
    }

    return true;
  }

  tcValidator(tc: String) {
    let sum = 0;
    for (let i = 0; i < tc.length - 1; i++) {
      const digit = parseInt(tc[i]);
      if (Number.isNaN(digit)) return false;

      sum += digit;
    }

    return sum % 10 === parseInt(tc[tc.length - 1]);
  }
}
